import { render, staticRenderFns } from "./AddVocabulary.vue?vue&type=template&id=d30d6f70&"
import script from "./AddVocabulary.vue?vue&type=script&lang=js&"
export * from "./AddVocabulary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports